import { gsap } from 'gsap';
import 'slick-carousel';
import 'bootstrap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import 'jquery.cookie';

var markers = false;

var is_mobile = false;


var windowWidth = window.innerWidth;
var windowHeight = window.innerHeight;
window.addEventListener('resize', function() {
 windowWidth = window.innerWidth;
 windowHeight = window.innerHeight; 

 checkIsMobile();
});


document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.menu-toggle');
  const menuContainer = document.querySelector('.menu-main-menu-container');

  // Funkcja zmieniająca stan aktywny przycisku i menu
  menuToggle.addEventListener('click', function() {
    menuToggle.classList.toggle('is-active'); // Zmiana wyglądu przycisku (krzyżyk)
    if(menuContainer)
    menuContainer.classList.toggle('is-open'); // Ukrywanie/wyświetlanie menu
  });
});

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

function checkIsMobile(){
  if (isMobileDevice() && $('#is_mobile').css('display') === 'block') {
    is_mobile = true;
  }else{
    is_mobile = false;
  }

}

function scrollTo(hash){
  
  $('html, body').animate({
    scrollTop: $(hash).offset().top

  }, 500, function(){
    setTimeout(function(){
      ScrollTrigger.refresh();
    }, 1000);
  });
}
gsap.registerPlugin(ScrollTrigger);
var containerWidth = 0;
document.addEventListener('DOMContentLoaded', function() {
  containerWidth = $('#container_width').outerWidth();
  
  
});

$(document).ready(function() {
  // Step 2: Add .active class when item is in the center of #kalendarium
 
});
document.addEventListener('DOMContentLoaded', function() {
  
  checkIsMobile();

  var headerHeight = $('#masthead').outerHeight(false);
  var offset = $('#offset_height').height();
  
 

  window.addEventListener('scroll', () => {
    if (window.scrollY > 150) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  });

  if (window.location.hash) {
    // Pobiera hash z URL
    const hash = window.location.hash.substring(1); // Usuwa # z początku
      // Przewija stronę do elementu o ID odpowiadającym hashowi
      const element = document.getElementById(hash);
      if (element) {
        // scrollTo('#'+hash);          
      }
  }



if(!is_mobile){
  
  gsap.utils.toArray(".imagesHolder.paralax .paralax-item").forEach((item) => {
    // Get the parallax speed from the 'paralax-speed' attribute
    let speed = parseFloat(item.getAttribute("paralax-speed")) || 0.1;

    // Create the parallax scroll animation for each item
    gsap.to(item, {
      y: () => -(window.innerHeight * speed), // Adjust movement based on scroll and speed
      ease: "none", // Smooth linear movement
      scrollTrigger: {
        trigger: ".imagesHolder.paralax",
        start: "top top", // Starts when the container is in view
        end: "bottom top",   // Ends when container scrolls out of view
        scrub: true          // Smooth scroll effect
      }
    });
  });

  function readAnimationProperty(anim){
    var animation = anim.split(',').reduce((acc, part) => {
      const [key, value] = part.split(':').map(item => item.trim());
      // Remove quotes from the value if they exist
      acc[key] = value.replace(/^'|'$/g, '');
      return acc;
  }, {});
    return animation;
  }

  
  function animateCurrent(id){
    $('#'+id+' .animation').each(function(){
      var end = $(this).attr('animation_end');

      var animation = readAnimationProperty(end);

      gsap.to($(this), animation);
    });
  }

  function animateCurrenBack(id){
    $('#'+id+' .animation').each(function(){
      var end = $(this).attr('animation_start');
      var animation = readAnimationProperty(end);

      gsap.to($(this), animation);
    });
  }
  

  $('.animation_sections').each(function(){
    var id = $(this).attr('id');

    animateCurrenBack(id);
    var start = $(this).attr('animation_start');

    ScrollTrigger.create({
      trigger: "#"+id, // Element, który chcemy przypiąć
      start: start,   // Zacznij, gdy element dotknie górnej krawędzi okna
      onEnter: () => { animateCurrent(id); },
      onLeaveBack: () => { animateCurrenBack(id); },
      markers: false
    });
  });



}

 });
function cookiesPolicyBar(){
  // Check cookie 


  if ($.cookie('cooki-policy-awx') != "active") {
    $('#cookieAcceptBar').show(); 
  }
  //Assign cookie on click
  $('#cookieAcceptBarConfirm').on('click',function(){
      $.cookie('cooki-policy-awx', 'active', { expires: 1 }); // cookie will expire in one day
      $('#cookieAcceptBar').fadeOut();
  });
}

jQuery(document).ready(function($){
  cookiesPolicyBar();

  // init();
  updateContent($('body'));


  $('.playButton').each(function(){

    var videoId = is_mobile ? $(this).attr('play_target_mobile') : $(this).attr('play_target');

    var myVideo = document.getElementById(videoId); 
    var vid = $('#'+(videoId)); 
    var button = $(this);
    myVideo.addEventListener('ended', function() {
      button.removeClass('active');
    });
    button.on('click', function(){
      if (myVideo.paused) {
        myVideo.play(); 
        button.addClass('active');
        vid.addClass('active');
      } else {
        myVideo.pause();
        button.removeClass('active');
        vid.removeClass('active');
      }
    });
  });
  
  $('.slickStop').on('click', function(){
    var slickSLider = $('#'+$(this).attr('slick_target'));

    const isPaused = slickSLider.slick('slickGetOption', 'autoplay') && slickSLider[0].slick.paused;

    slickSLider.slick('slickPause');
    if (isPaused) {
      slickSLider.slick('slickPlay');
    } else {
      slickSLider.slick('slickPause');
    }
  });

   $('#site-navigation li.menu-item a').each(function(){
      $(this).on('click', function(){
        
        var href = $(this).attr('href');
        var hash = href.split('/').join('');

        scrollTo(hash);

        if(is_mobile === true){
          $('.menu-toggle').removeClass('is-active');
          $('.menu-main-menu-container').removeClass('is-open');
        
        }

        return false;
      });
   });

   
  //  slickContinuousScroll('#clients_holder');

  $('body').scrollspy({ target: '#primary-menu' });

  $('body').on('activate.bs.scrollspy', function () {
    var href = $('#primary-menu li.menu-item a.active').attr('href');

    if(href){

    var id = href.split('/#').join('');
    updateURL(id);

    }else{
      updateURL('');
    }
  })
});


const updateURL = (id) => {
  if (history.pushState) {
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}#${id}`;
    history.pushState(null, '', newUrl);
  }
};


function updateContent(parent){


  $('#image_holder').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '#galeria_holder'
  });
  $('#galeria_holder').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '#image_holder',
    dots: false,
    centerMode: true,
    variableWidth: true,
    focusOnSelect: true,
    infinite: true,
    draggable: false,
    speed: 500, 
    autoplaySpeed: 2500,
    autoplay: true,
  });



   measureSlickSlides();

   adjustSliderPosition();
   $('#galeria_holder').on('afterChange', function() {      
       adjustSliderPosition();
   });



   $('#video_slider_holder').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    centerMode: true,
    variableWidth: true,
    focusOnSelect: true,
    infinite: true,
    draggable: false,
    speed: 500, 
    autoplaySpeed: 2500,
    autoplay: true,
  });


}
var currMargin = 0;

function measureSlickSlides(){
  $('.slick-slide').each(function(){
    var measurewidth = $(this).find('img').outerWidth();
    $(this).attr('slide_width', measurewidth);
  });
}

function adjustSliderPosition() {
  const containerOffset = $('#container_width').width(); // Left offset of .container  
  const slickCurrent = $('#galeria_holder .slick-current').width(); // Select .slick-current slide
  const slicBkCurrent = $('#image_holder .slick-current img').width(); // Select .slick-current slide

  var galleryMargin = calcToRem(containerOffset/2-slickCurrent/2);
  
  if(currMargin){
    galleryMargin -= currMargin;
  }

  currMargin = calcToRem(slicBkCurrent-slickCurrent);
  // $('#galeria_holder .slick-list .slick-track .slick-slide').css({'margin-right':'0rem'});
  // $('#galeria_holder .slick-list .slick-track').css({'margin-left':-galleryMargin + 'rem'});
  // $('#galeria_holder .slick-list .slick-track .slick-current').css({'margin-right': currMargin + 'rem'});
}

function calcToRem(px){
  return px/14;
}

function circumference(r) {
  if (Number.isNaN(Number.parseFloat(r))) {
    return 0;
  }
  return parseFloat(r) ;
}

function slickInit(slick, currentTarget){
  var moveDots = $(slick.target).hasClass('moveDots') ? true : false;
  if(moveDots){
    var moveDotsTo = $($(slick.target).attr('move-dots-to'));
    var moveDotsFrom = $($(slick.target).find('.slick-dots'));
    moveDotsFrom.addClass('slick-dots-outside');
    moveDotsTo.append(moveDotsFrom);
  }

}



if($('#w_liczback').length > 0){
  gsap.set("#w_liczback", {perspective:1500, scale:0.7125})
  gsap.set(".upper", {rotationX:0.01, transformOrigin:"50% 100%"})
  gsap.set(".lower", {rotationX:0.01, transformOrigin:"50% 0%"})

  tick(number, 100);

  var w_liczback_i = 0;

  setInterval(displayNextNumberWLIczbach, 3000);
  displayNextNumberWLIczbach();
}


function displayNextNumberWLIczbach(){

  var gett = $('#w_liczback_clock_data li').eq(w_liczback_i);
  var dataa;
  if(gett.length){
    dataa = gett;
  }else{
    w_liczback_i=0;
    dataa = $('#w_liczback_clock_data li').eq(w_liczback_i);
  }

  var num = dataa.attr('data_number');
  gsap.set("#w_liczbach_description", {alpha:0})
  $('#w_liczbach_description .unit').text(dataa.attr('data_unit'));
  $('#w_liczbach_description .desc').text(dataa.html());
  gsap.to("#w_liczbach_description", {alpha:1, ease:"Bounce.easeOut", delay:.3})  
  tick(number, num);
   

  w_liczback_i++;
}

if($('#clock').length > 0){
// set 3d transforms
// gsap.set("#clock", {perspective:1500, scale:0.7125})
gsap.set(".upper", {rotationX:0.01, transformOrigin:"50% 100%"})
gsap.set(".lower", {rotationX:0.01, transformOrigin:"50% 0%"})

var i = 0;

setInterval(displayNextNumber, 3000);
displayNextNumber();

}

function displayNextNumber(){

  var gettt = $('#clock_data li').eq(i);
  var data;
  if(gettt.length){
    data = gettt;
  }else{
    i=0;
    data = $('#clock_data li').eq(i);
  }

  var hh = data.attr('data_year');
  var nn = data.html();


  setTimeout(function(){
    tick(y1, Number(hh.substr(0,2)))
  }, 100);
  setTimeout(function(){
    tick(y2, Number(hh.substr(2,2)))
  }, 300);
  
  setTimeout(function(){
    tick(n, nn)
  }, 500);

  i++;
}








function tick(mc,i){

  // set numbers
  mc.childNodes[1].innerHTML = "<span>"+(i)+"</span>"; //end upper
  mc.childNodes[7].innerHTML = "<span>"+(i)+"</span>"; //end lower
  // animate tick
  gsap.fromTo(mc.childNodes[1], .3, {alpha:0},{alpha:1, ease:"power2.easeIn"})  
  gsap.fromTo(mc.childNodes[3], .3, {rotationX:0, background:"linear-gradient(0deg, rgba(200,200,200,1), rgba(255,255,255,1) 15%)"},{rotationX:-90, ease:"power2.easeIn"})
  gsap.fromTo(mc.childNodes[7], .5+.2*Math.random(), {rotationX:90},{rotationX:0, ease:"Bounce.easeOut", delay:.3})
  gsap.fromTo(mc.childNodes[5], .6, {alpha:1},{alpha:0, ease:"Bounce.easeOut", delay:.3})  
}




